import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
// Portal do Aluno
import Portal from "./views/Portal.vue";
// Segmentos
import Seg_EducacaoInfantil from "./views/segmentos/EducacaoInfantil.vue";
import Seg_EnsinoFund1 from "./views/segmentos/EnsinoFund1.vue";
import Seg_EnsinoFund2 from "./views/segmentos/EnsinoFund2.vue";
// Institucinal
import Ins_Historia from "./views/institucional/Historia.vue";
import Ins_Calendario from "./views/institucional/Calendario.vue";
import Ins_Equipe from "./views/institucional/Equipe.vue";
import Ins_EspacoFisico from "./views/institucional/EspacoFisico.vue";
import Ins_ListaMateriais from "./views/institucional/ListaMateriais.vue";
import Ins_Uniformes from "./views/institucional/Uniformes.vue";
import Ins_SeguroAlunos from "./views/institucional/SeguroAlunos.vue";
import Ins_Campanhas from "./views/institucional/Campanhas.vue";
import Ins_MaterialPublicitario from "./views/institucional/MaterialPublicitario.vue";
import Ins_Logo from "./views/institucional/Logo.vue";
// Pedagogico
import Ped_Proposta from "./views/pedagogico/Proposta.vue";
import Ped_Extracurriculares from "./views/pedagogico/Extracurriculares.vue";
import Ped_Convenios from "./views/pedagogico/Convenios.vue";
// Fotos
import Fotos from "./views/Fotos.vue";
// Atendimento
import Ate_FaleConosco from "./views/atendimento/FaleConosco.vue";
import Ate_Localizacao from "./views/atendimento/Localizacao.vue";
import Ate_TrabalheConosco from "./views/atendimento/TrabalheConosco.vue";
// Matrículas
import Matriculas from "./views/Matriculas.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    // HOME
    {
      path: "/",
      name: "home",
      component: Home
    },
    // PORTAL DO ALUNO
    {
      path: "/portal",
      component: Portal
    },
    // SEGMENTOS...
    {
      path: "/segmentos/educacao-infantil",
      component: Seg_EducacaoInfantil
    },
    {
      path: "/segmentos/ensino-fundamental-1",
      component: Seg_EnsinoFund1
    },
    {
      path: "/segmentos/ensino-fundamental-2",
      component: Seg_EnsinoFund2
    },
    // INSTITUCIONAL...
    {
      path: "/institucional/historia",
      component: Ins_Historia
    },
    {
      path: "/institucional/calendario",
      component: Ins_Calendario
    },
    {
      path: "/institucional/equipe",
      component: Ins_Equipe
    },
    {
      path: "/institucional/espaco-fisico",
      component: Ins_EspacoFisico
    },
    {
      path: "/institucional/lista-de-materiais",
      component: Ins_ListaMateriais
    },
    {
      path: "/institucional/seguro-dos-alunos",
      component: Ins_SeguroAlunos
    },
    {
      path: "/institucional/uniformes",
      component: Ins_Uniformes
    },
    {
      path: "/institucional/campanhas",
      component: Ins_Campanhas
    },
    {
      path: "/institucional/material-publicitario",
      component: Ins_MaterialPublicitario
    },
    {
      path: "/institucional/logo",
      component: Ins_Logo
    },
    // PEDAGÓGICO...
    {
      path: "/pedagogico/proposta",
      component: Ped_Proposta
    },
    {
      path: "/pedagogico/extracurriculares",
      component: Ped_Extracurriculares
    },
    {
      path: "/pedagogico/convenios",
      component: Ped_Convenios
    },
    // FOTOS
    {
      path: "/fotos",
      component: Fotos
    },
    // ATENDIMENTO...
    {
      path: "/atendimento/fale-conosco",
      component: Ate_FaleConosco
    },
    {
      path: "/atendimento/localizacao",
      component: Ate_Localizacao
    },
    {
      path: "/atendimento/trabalhe-conosco",
      component: Ate_TrabalheConosco
    },
    // MATRICULA
    {
      path: "/matriculas",
      component: Matriculas
    },

    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    },
    { path: "*", redirect: "/" }
  ]
});
